<template>
  <div class="toastPage">{{message}}</div>
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  $px: (.05rem);

  .toastPage {
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 14*$px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) translateZ(1px);
    border-radius: 4*$px;
    padding: 10*$px;
    white-space: nowrap;
    animation: show 3s forwards ease-in;
    z-index: 9999;

    @keyframes show {
      0% {
        opacity: 0;
      }

      20% {
        opacity: 1;
      }

      80% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/ui/base/components/toast.vue